
















import { Component } from 'vue-property-decorator';

import { Surface, Typography, Picture } from '@/components/atoms';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import SocialRewardsDescription from './SocialRewardsDescription.vue';
import BillingModel from '@/views/Models/BillingModel.vue';

@Component({
  components: {
    Surface,
    Typography,
    Picture,
    FilledButton,
    SocialRewardsDescription
  }
})
export default class SocialRewardsEmptyState extends BillingModel {
  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get textButton() {
    if (this.inactiveBilling)
      return 'Upgrade & Get started with Social Rewards';
    return 'Get started with Social Rewards';
  }

  click() {
    if (this.inactiveBilling) {
      this.onClickUpgrade({
        onSuccess: () => {
          this.$emit('click');
        },
        props: {
          welcomeCtaText: 'Explore Social Rewards',
          origin: 'Empty State Social Rewards'
        }
      });
      return;
    }
    this.$emit('click');
  }
}
